/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcSystemVariantListResponse } from '../../models/bc-system-variant-list-response';

export interface GetAllSystemVariants$Params {
}

export function getAllSystemVariants(http: HttpClient, rootUrl: string, params?: GetAllSystemVariants$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcSystemVariantListResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllSystemVariants.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BcSystemVariantListResponse>>;
    })
  );
}

getAllSystemVariants.PATH = '/business-central/systems/variants/all';
